export default __webpack_public_path__ + "static/media/cancel.085e36bf.svg";